import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LabeledMedia from '../../components/LabeledMedia/LabeledMedia'
import "../../index.css";
import ContactSection from '../../components/ContactSection/ContactSection';
import CinematicContainer from '../../components/CinematicContainer/CinematicContainer';
import MediaService from '../../services/mediaService';



function HomePage() {
  const [heroVideo, setHeroVideo] = useState("")
  const [isPending, setIsPending] = useState(true)
  const [galleryPhotos, setGalleryPhotos] = useState([]);

  const [error, setError] = useState(null)
  const navigate = useNavigate()

  function handleNavigation(location){
    navigate(location)
  }

  useEffect(() => {
    let isActive = true
    let latestRequest = 0

    const loadHeroVideo = async () => {
      const requestId = ++latestRequest
      const videoId = window.innerWidth > window.innerHeight
        ? "hero-video-compressed-desktop.mp4"
        : "hero-video-compressed-mobile.mp4"

      try {
        setIsPending(true)
        setError(null)
        const data = await MediaService.getMediaUrl("assets", "video", "homepage", videoId)
        if (isActive && requestId === latestRequest) {
          setHeroVideo(data)
        }

        const secondaryData = await MediaService.getGallery("assets", "photo", "homepage")
        
        if (isActive && requestId === latestRequest) {
          setGalleryPhotos(secondaryData.filter(file => file.id !== "" && file.size > 0))
        }

      } catch (loadError) {
        if (isActive && requestId === latestRequest) {
          setError(loadError instanceof Error ? loadError : new Error(String(loadError)))
        }
      } finally {
        if (isActive && requestId === latestRequest) {
          setIsPending(false)
        }
      }
    };

    loadHeroVideo()
    window.addEventListener('resize', loadHeroVideo)

    return () => {
      isActive = false
      window.removeEventListener('resize', loadHeroVideo)
    }
  }, []);



  if (isPending) return "Loading..."

  if (error) return "An error has occurred: " + error.message


  return (
    <> 
      <LabeledMedia src={heroVideo} video/>

      <CinematicContainer 
  // Because of the possiblity of values not coming in order, we specifically serach for the 
  // id by title
  imgSrc = {galleryPhotos.find(photo => photo.id === "1-portrait-cover.webp").src}  
  title="PORTRAIT" 
  onClick={() => handleNavigation('/portrait')}
/>


<CinematicContainer 
  // Because of the possiblity of values not coming in order, we specifically serach for the 
  // id by title
    imgSrc = {galleryPhotos.find(photo => photo.id === "2-commercial-cover.webp").src}  
  title="COMMERCIAL" 
  onClick={() => handleNavigation('/commercial')}
/>


{/* <CinematicContainer 
  imgSrc="/photo-assets/cinematic/cinematic cover 2.jpg" 
  title="Cinematic" 
  onClick={() => handleNavigation('/cinematic')}
/> */}

<ContactSection bg="bg-dark"/>
    </>
  );
}

export default HomePage;
